import React from 'react';
import './Identity.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

function Identity() {
    return (
        <div className="identity">
            <img className="identityPhoto" alt="Logan Holmes" src="https://lbhportfolioimages.blob.core.windows.net/images/headshot.jpg" />
            <div className="identityText">
                <div className="identityName">Logan Holmes</div>
                <div className="identityTagline">Software engineer building computer vision and web apps</div>
                <div className="identityLinks">
                    <a href="mailto:loganholmes33@gmail.com"><FontAwesomeIcon icon={faEnvelope} /> loganholmes33@gmail.com</a>
                    <a href="https://www.linkedin.com/in/realloganholmes/" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faLinkedin} /> LinkedIn</a>
                </div>
            </div>
        </div>
    );
}

export default Identity;
